export const NOTIFICATION_DURATION = '5000'
export const REGEX_MAIL = /\S+@\S+\.\S+/

export const MURET_LAT_LNG = { lat: 43.45014022019188, lng: 1.2651294267719573 }

export const MARKER_SVG_PATH = 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z'
